import { render, staticRenderFns } from "./router-view-provider.vue?vue&type=template&id=5036be40&"
import script from "./router-view-provider.vue?vue&type=script&lang=js&"
export * from "./router-view-provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports